<template>
  <div class="expirado-wrap">
    <div class="expirado-card" role="alert" aria-live="polite">
      <div class="expirado-icon">⛔</div>
      <h2 class="expirado-title">{{ $t('pronostico.expiredTitle') }}</h2>
      <p class="expirado-msg">{{ errorProducto || $t('pronostico.expiredDefault') }}</p>
      <div class="expirado-actions">
        <button class="expirado-btn secundario" @click="$router.push('/')">{{ $t('pronostico.backHome') }}</button>
        <button class="expirado-btn" @click="location.reload()">{{ $t('pronostico.reload') }}</button>
      </div>
      <p class="expirado-foot">{{ $t('pronostico.expiredHelp') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PronosticoServicioNoDisponible",
  props: {
    errorProducto: { type: String, default: "" },
  },
};
</script>
